import { render, staticRenderFns } from "./WotLazyImage.vue?vue&type=template&id=05efbce5"
import script from "./WotLazyImage.vue?vue&type=script&lang=js"
export * from "./WotLazyImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports